import React from "react";
import { Route, Redirect } from "react-router-dom";

import AlunoFinanceiro from "@/pages/Aluno/Financeiro";

export default function FinanceiroRoute({ auth, ...rest }) {
    // identificar se o usuario está logado
    const { authenticated, data } = auth;

    if (!authenticated) {
        return (
            <Route
                {...rest}
                render={props => <Redirect to={{ pathname: "/login" }} />}
            />
        );
    }

    const { tipo, empresa } = data;
    let Component;

    switch (true) {
        case tipo === "aluno":
            Component = AlunoFinanceiro;
            break;
        case ["funcionario", "supervisor"].includes(tipo) && !empresa.is_escola:
            Component = <div>Financeiro não disponível para empresas</div>;
            break;
        case ["funcionario", "supervisor"].includes(tipo) && empresa.is_escola:
            Component = <div>Financeiro não disponível para escolas</div>;
            break;
        case ["administrador"].includes(tipo):
            Component = <div>Financeiro não disponível para administrador</div>
            break;
    }

    return <Route {...rest} render={props => <Component {...props} />} />

}
